'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/offers', {
      template: require('./offers.pug'),
      controller: 'OffersController',
      controllerAs: 'offers',
    });
};




// WEBPACK FOOTER //
// ./client/app/manager/offers/offers.routes.ts